export const data = [
  {
    categories: [
      {
        name: "Produce",
        icon: <i className="fa-solid fa-carrot"></i>,
        products: [
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
        ],
      },
      {
        name: "Prepared Foods",
        icon: <i className="fa-solid fa-ice-cream"></i>,
        products: [
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
        ],
      },

      {
        name: "Canned Foods & Soups",
        icon: <i className="fa-solid fa-fish"></i>,
        products: [
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
        ],
      },
      {
        name: "Frozen",
        icon: <i className="fa-solid fa-jar"></i>,
        products: [
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
        ],
      },
      {
        name: "Produce",
        icon: <i className="fa-solid fa-carrot"></i>,
        products: [
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
        ],
      },
      {
        name: "Sweets",
        icon: <i className="fa-solid fa-cheese"></i>,
        products: [
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
        ],
      },
      {
        name: "Diary & Eggs",
        icon: <i className="fa-solid fa-egg"></i>,
        products: [
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
        ],
      },
      {
        name: "Frozen",
        icon: <i className="fa-solid fa-jar"></i>,
        products: [
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
        ],
      },
      {
        name: "Meat & Seafood",
        icon: <i className="fa-solid fa-bone"></i>,
        products: [
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
        ],
      },
      {
        name: "Sweets",
        icon: <i className="fa-solid fa-cheese"></i>,
        products: [
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
        ],
      },
      {
        name: "Produce",
        icon: <i className="fa-solid fa-carrot"></i>,
        products: [
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
        ],
      },

      {
        name: "Sweets",
        icon: <i className="fa-solid fa-cheese"></i>,
        products: [
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
        ],
      },
      {
        name: "Prepared Foods",
        icon: <i className="fa-solid fa-ice-cream"></i>,
        products: [
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
        ],
      },

      {
        name: "Canned Foods & Soups",
        icon: <i className="fa-solid fa-fish"></i>,
        products: [
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
        ],
      },
      {
        name: "Frozen",
        icon: <i className="fa-solid fa-jar"></i>,
        products: [
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
        ],
      },
      {
        name: "Prepared Foods",
        icon: <i className="fa-solid fa-ice-cream"></i>,
        products: [
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
        ],
      },

      {
        name: "Canned Foods & Soups",
        icon: <i className="fa-solid fa-fish"></i>,
        products: [
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Banana",
            price: 0.69,
            quantity: "18oz",
            image: "./Assets/banana.png",
          },
          {
            name: "Strawberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/strawberry.png",
          },
          {
            name: "Yogurt",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/yogurt.png",
          },
          {
            name: "Blackberries",
            price: 0.69,
            quantity: "1lb",
            image: "./Assets/blackberries.png",
          },
        ],
      },
    ],
  },
];
